import {create} from 'zustand';
import {persist} from 'zustand/middleware';

const usePersistentStore = create(
  persist(
    set => ({
      // Control visible metrics in AccountPropertiesSelection
      enabledMetrics: {
        viewability: true,
        requests: true,
        revenue: true,
        ecpm: true,
      },

      comparisonEnabled: true,
      comparisonMode: 'equivalent',

      googleAuth: false,
      preferredTimezone: null,

      // Control default tab in Home page (Hourly, Daily, Prices, etc)
      defaultTab: 0,
      columnsStartIndex: 0,
      maxVisibleColumns: 3,
      analyticsGrouping: 'bidder',
      columnsOrder: null,
      autoRefreshEnabled: true,
      /** Realtime only: auto-refresh interval in seconds (see REALTIME_REFRESH_INTERVAL_OPTIONS). */
      realtimeRefreshIntervalSeconds: 15,
      realtimeMinutes: 10,
      stackedReportEnabledMetricDefault: 'Paid Imp',
      stackedReportEnabledMetricAnalytics: 'TotalImpressions',
      /** Main stacked graph area height (px); sticky height scales with default ratio). */
      stackedReportGraphHeightPx: 432,
      /** When true, chart area is hidden; table and filters remain. */
      stackedReportGraphHidden: false,
      /** Keep the stacked graph visible while scrolling the table below. */
      stickyGraphEnabled: false,
      /** Lock vertical axis scale when toggling metrics (grouped graph only). */
      fixedScale: false,
      /** Center graph tooltip for easier scrolling. */
      centerTooltip: false,
      /** Show full numbers instead of millified values in the table. */
      disableMillify: false,
      /** Enterprise prebid: show NET reseller revenue after commission. */
      showNetPrebidResellerRevenue: false,
      /** Analytics: overlay ad-setup change history (guide lines + change log) on the chart. */
      analyticsChangeLogEnabled: true,
      /** Prebid stack: overlay Direct/Reseller SSP switch markers on the chart. */
      prebidSspChangesEnabled: true,
      stackedExportOptions: {
        sourcesScope: 'all',
        metricsScope: 'all',
        includeTotals: true,
        includePercentOfTotal: false,
        includeComparison: false,
        fileType: 'xlsx',
      },
      /** Client opt-in: show in-app API inspector (production). */
      apiInspectorEnabled: false,
      keepSignedIn: true,

      changeEnabledMetric: (metric, value) => {
        set(state => ({
          enabledMetrics: {
            ...state.enabledMetrics,
            [metric]: value,
          },
        }));
      },

      setDefaultTab: tab =>
        set(() => ({
          defaultTab: tab,
        })),

      // Global state change function, two params - first is key of state, second is data
      setState: (key, data) => {
        set(() => ({
          [key]: data,
        }));
      },
    }),
    {
      name: 'client-ui-persistent-storage',
      version: 3,
    }
  )
);

export default usePersistentStore;
